import HTTPResponseBuilder from "./HTTPResponseBuilder.js"

/**
 * @description
 *	An HTTP/HTTPS response.
 */
export default class HTTPResponse<O> {
	public readonly body: O | undefined
	public readonly headers: Record<string, string>
	public readonly statusCode: number
	public readonly statusText: string

	public constructor(builder: HTTPResponseBuilder<O>) {
		this.body = builder._body
		this.headers = builder._headers
		this.statusCode = builder._statusCode
		this.statusText = builder._statusText
	}
}
